import Hosts from '../../../../Hosts';

const object_type = 'store/shipping/preferences'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/store_preferences'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    //list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        handling_charges: '',
        free_shipping_value: '',
        free_shipping_weight: '',
        carrier: {},
        sort_by: '',
        order_by: '',
        status: true,
    }
}
export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}